import { BaseEntity } from "yt-ng-framework";

export class CompanyEmail extends BaseEntity{
    constructor(){
        super();
    }

    FirmaID: number = null;
    Naziv:string = null;
    SvojinaID:number = null;
    Glavni:boolean = null;
    // Opis: string = null;
    Opis: string = "";

    Deserialize(input:any){
        this.ID=input.ID;
        this.FirmaID=input.FirmaID;
        this.Naziv=input.Naziv;
        this.SvojinaID=input.SvojinaID;
        this.Glavni=input.Glavni;
        this.Opis=input.Opis;
        return this;
    }

    Serialize(input:CompanyEmail){
        return input;
    }
}